const Swal = require('sweetalert2');
const toastr = require('toastr');

const bsSwal = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary mx-1',
      cancelButton: 'btn btn-danger mx-1'
    },
    buttonsStyling: false,
    reverseButtons: true
});

document.addEventListener("DOMContentLoaded", function(event) { 

    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toast-bottom-left",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "200",
        "hideDuration": "1000",
        "timeOut": "2000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };
    
    // show_messages();

});

// function show_messages(){

//     if(typeof _messages == 'object'){

//         if(typeof _messages.info != 'undefined' && _messages.info != ''){
//             info(_messages.info);
//         }

//         if(typeof _messages.success != 'undefined' && _messages.success != ''){
//             success(_messages.success);
//         }

//         if(typeof _messages.warning != 'undefined' && _messages.warning != ''){
//             warning(_messages.warning);
//         }

//         if(typeof _messages.error != 'undefined' && _messages.error != ''){
//             error(_messages.error);
//         }

//         if(typeof _messages.errors == 'object'){
//             for(let _error of _messages.errors){
//                 if(_error != ''){
//                     error(_error);
//                 }
//             }
//         }

//     }

// }

export function success(message){

    bsSwal.fire({
        text: message,
        icon: "success",
        confirmButtonText: window.__('Ok'),
    });

    console.log('(success) ' + message);

}

export function error(message){
    
    bsSwal.fire({
        text: message,
        icon: "error",
        confirmButtonText: window.__('Ok'),
    });

    console.log('(error) ' + message);

}

export function info(message){
    
    toastr.success(message);

    console.log('(info) ' + message);

}

export function warning(message){
    
    bsSwal.fire({
        text: message,
        icon: "warning",
        confirmButtonText: window.__('Ok'),
    });

    console.log('(warning) ' + message);

}

export function confirm(title, text){
    return new Promise((resolve, reject) => {

        bsSwal.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: window.__('Si'),
            cancelButtonText: window.__('No'),
            reverseButtons: false,
        }).then((result) => {
            if(result.isConfirmed){
                resolve();
            } else {
                reject();
            }
        });

    });
}